import { h } from 'preact'
import Moment from 'moment'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const ProjectModal = (props) => {

    let project = props.project
    let title = project.title.rendered
    let branches = project.branch_names
    let link = project.link
    let excerpt = project.excerpt.rendered
    let raw_date = project.date
    let date = Moment(raw_date).format('DD/MM/YYYY')
    let feat_image = project.feat_image

    let text_show = 'Bekijk'

    if (props.language == 'en') {
        text_show = 'View'
        date = Moment(raw_date).format('MM/DD/YYYY')
    }

    return (
        <div id={'project-modal-' + project.id}
             className="modal project-modal fade"
             tabIndex="-1"
             role="dialog">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-body">
                        <button type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close">
                            <i className="fas fa-times"></i>
                        </button>
                        <div className="image-gallery projects">
                            {
                                typeof project.extra[0].repeater !== 'undefined'
                                    ? project.extra[0].repeater.map((slide) => {
                                            return (
                                                <div className="slide">
                                                    <div className="desktop" dangerouslySetInnerHTML={{ __html: slide.image }} />
                                                    <div className="mobile" dangerouslySetInnerHTML={{ __html: slide.image_mobile }} />
                                                </div>
                                            )
                                        })
                                    : ''
                            }
                        </div>
                        <div className="content">
                            <div className="inner">
                                <h2 className="modal-title" dangerouslySetInnerHTML={{ __html: title }} />
                                <div className="project-info">
                                    <div className="project-info-detail">
                                        <p className="project-info-title">Categorie</p>
                                        <p className="project-info-text">
                                            {branches.join(', ')}
                                        </p>
                                    </div>
                                    <div className="project-info-detail">
                                        <p className="project-info-title">Opdracht</p>
                                        <p className="project-info-text">
                                            {typeof project.extra[0].assignment !== 'undefined' ? project.extra[0].assignment : ''}
                                        </p>
                                    </div>
                                </div>
                                <div className="info" dangerouslySetInnerHTML={{ __html: typeof project.extra[0].text !== 'undefined' ? project.extra[0].text : '' }}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProjectModal

// WEBPACK FOOTER //
// ./src/js/projects/components/Project.js
